import { useCallback, useEffect, useState } from "react";
import {
  fetchAccessCompany,
  fetchAllAccessUser,
  fetchAllCompany,
  fetchLoginuser,
  fetchUser,
} from "../services/commonServices";
import { viewAllCompany } from "../services/commonServices";
import {
  getSelectedCompany,
  storeAccessCondition,
  storeCompanyDetails,
  storeSelectedCompany,
  storeUserDetails,
  storeUserToken,
} from "../utils/auth";

export const useSelectBoxCompany = () => {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetchAllCompany();
        setCompanies(response.get_company_group_channel);
      } catch (error) {}
    };
    fetchCompanies();
  }, []);

  return companies;
};

export const useAccessUser = () => {
  const [user, setUser] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetchAllAccessUser();
        setUser(response.get_company_group_channel);
      } catch (error) {}
    };
    fetchUser();
  }, []);

  return user;
};

export const useFetchSelectedUser = (id, search) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUserList = async () => {
      if (id) {
        // only fetch if id is valid
        try {
          const response = await fetchUser(
            `?company_id=${id}&search=${search || ""}`
          );
          setUsers(response.get_company_group_channel);
        } catch (error) {}
      }
    };

    fetchUserList(); // call the function when id changes
  }, [id, search]); // dependency array to trigger on id change

  return users;
};

export const useFetchUserCompany = (id) => {
  const [company, setCompany] = useState([]);

  useEffect(() => {
    const fetchCompany = async () => {
      if (id) {
        // only fetch if id is valid
        try {
          const response = await fetchAccessCompany(`?register_id=${id}`);
          setCompany(response.get_company_group_channel);
        } catch (error) {}
      }
    };

    fetchCompany(); // call the function when id changes
  }, [id]); // dependency array to trigger on id change

  return company;
};

export const useCompanySelect = () => {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await viewAllCompany();

        const formatted = response.get_company.map((c) => ({
          value: c.id,
          label: c.company_name,
        }));
        setCompanies(formatted);
      } catch (error) {}
    };

    fetchCompanies();
  }, []);

  return companies;
};

export const useLoginUser = () => {
  const [userData, setUserData] = useState([]);
  const selctedComp = getSelectedCompany();

  const fetchRegisterUser = useCallback(async () => {
    try {
      const response = await fetchLoginuser();

      storeUserToken(response.login_data.token);
      storeUserDetails(response.login_data.employee_details);
      storeCompanyDetails(response.login_data.company_details);
      storeAccessCondition(response.login_data?.access_category[0]);
      const viewCompany = response.login_data?.company_details?.filter(
        (comp) => comp.id === selctedComp.id
      );
      storeSelectedCompany(viewCompany[0]);

      setUserData(response.login_data);
    } catch (error) {
      console.error("Error fetching login user:", error);
    }
  }, [selctedComp.id]); // depends only on selected company id

  useEffect(() => {
    fetchRegisterUser();
  }, [fetchRegisterUser]);

  return { userData, refreshLoginData: fetchRegisterUser };
};
